import { TPPClaimsState } from "@/models/store/TPPClaimsState";

export const incidentInfoMutations = {
  setClaimIncidentDate: (state: TPPClaimsState, date: string) => {
    state.selectedTPPClaim!.incident_date = date;
  },
  setClaimLossType: (state: TPPClaimsState, lossType: string) => {
    state.selectedTPPClaim!.loss_type = lossType;
  },
  setClaimLawEnforcementName: (state: TPPClaimsState, lawEnforcementName: string) => {
    state.selectedTPPClaim!.authority_name = lawEnforcementName;
  },
  setClaimFiledReport: (state: TPPClaimsState, filedReport: string) => {
    state.selectedTPPClaim!.authority_filed_report = filedReport;
  }
};
